import { WEBCAM_CHANNELS } from "@serendiptv/contracts";
import type { StationSummary } from "../types";

export interface Webcam {
  channel: number;
  name: string;
  location: string;
  provider: string;
  videoId: string;
  sourceUrl: string;
  availability: string;
}

// Reserved viewer channels. Use only owner-published, embedding-enabled feeds.
// Verification evidence and the update procedure live in docs/webcams.md.
export const WEBCAMS: readonly Webcam[] = [
  { channel: WEBCAM_CHANNELS[0], name: "Times Square", location: "New York, New York", provider: "EarthCam", videoId: "JQ_jwk_7OVE", sourceUrl: "https://www.youtube.com/watch?v=JQ_jwk_7OVE", availability: "Around-the-clock city views; interruptions are possible." },
  { channel: WEBCAM_CHANNELS[1], name: "Anglins Pier", location: "Lauderdale-by-the-Sea, Florida", provider: "EarthCam", videoId: "tAdTOOsrZBQ", sourceUrl: "https://www.youtube.com/watch?v=tAdTOOsrZBQ", availability: "Around-the-clock coastal views; nighttime may be dark." },
  { channel: WEBCAM_CHANNELS[2], name: "Glensheen Lake", location: "Duluth, Minnesota", provider: "Glensheen / Duluth Harbor Cam", videoId: "KYxUtgc-_Og", sourceUrl: "https://www.youtube.com/watch?v=KYxUtgc-_Og", availability: "Lake Superior views; weather and darkness affect visibility." },
  { channel: WEBCAM_CHANNELS[3], name: "Jackson Town Square", location: "Jackson, Wyoming", provider: "See Jackson Hole", videoId: "B_waF26In9o", sourceUrl: "https://www.youtube.com/watch?v=B_waF26In9o", availability: "Around-the-clock town views; interruptions are possible." },
  { channel: WEBCAM_CHANNELS[4], name: "Monterey Bay", location: "Monterey, California", provider: "Monterey Bay Aquarium", videoId: "fVa6-zCBR7A", sourceUrl: "https://www.youtube.com/watch?v=fVa6-zCBR7A", availability: "Live 7 a.m.–7 p.m. Pacific. The provider may show recordings outside these hours." }
];

export function webcamForChannel(channel: number): Webcam | undefined {
  return WEBCAMS.find((camera) => camera.channel === channel);
}

export function withWebcamStations(stations: StationSummary[]): StationSummary[] {
  return [
    ...stations.filter((station) => !webcamForChannel(station.channel)),
    ...WEBCAMS.map((camera) => ({ id: `webcam-${camera.channel}`, channel: camera.channel, call_sign: `CAM ${camera.channel}`, name: camera.name, identity: camera.location }))
  ].sort((a, b) => a.channel - b.channel);
}
